import React, { useState, useEffect } from 'react';
import { 
  PlayArrow,
} from '@mui/icons-material';

import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function PlayButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <PlayArrow className={ disabled ? "gray" : "green clickable"}
        onClick={() => { 
          if (!disabled) {
            onClick();
          }
        }}
      />
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={() => { 
          if (!disabled) {
            onClick();
          }
        }}
        variant="contained" color="primary">
        <PlayArrow/>&nbsp;{ label }
      </Button>
    );
  }
}
